export default "__VITE_ASSET__BkfeYylT__"